<template>
  <div>
    <aha-icon-button
      v-if="canUseNewCleanUpEditorUI"
      variant="tertiary"
      @click="$emit('showDownload')"
      v-tooltip="$i18nPresenter.t('Export')"
    >
      <aha-icon
        name="FileArrowDown"
      />
    </aha-icon-button>
    <a
      v-else
      @click="$emit('showDownload')"
      class="tab-trigger-btn text-link font-bold"
      :class="{ 'tab-trigger-btn--active':isActive }"
    >
      <aha-icon
        class="mb-0.5 mr-0 xl:mr-1"
        name="download"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        v-tooltip="$i18nPresenter.t('Export')"
      />
    </a>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseNewCleanUpEditorUI']),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
}
</script>

<style lang="scss" scoped>
.tab-trigger-btn {
  @apply relative top-2 items-center px-1.5 xl:px-2 pt-2 pb-6;
  @apply flex;
  // only apply transition to color. Prevent wierd background flicker when applying --active class
  transition-property: color;

  &--active {
    @apply z-20 rounded-t-md text-primary-100;
    &:not(.share-v2){
      @apply bg-base-0
    }
  }
}
</style>
